import { downloadPoster, fetchPosterUrl } from 'utils/actions/rw-social-media/rw-social-media.actions';
import { checkAccess } from 'app/actions/app.actions';

import template from './rw-social-media.html';

const mapStateToThis = ({ session, ui, poster }) => {
  const { locale, retailer } = session;
  const { error } = ui;
  const { url, isLoading } = poster;

  return {
    locale,
    retailer,
    error,
    url,
    isLoading,
  };
};

const mapDispatchToThis = {
  downloadPoster,
  fetchPosterUrl,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', '$window', 'Notifications', 'gettextCatalog')
class RwSocialMediaController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.isSharingEnable = this.checkAccess('dashboard.dashboardShare');
    this.retailerId = parseInt(this.$state.params.retailerNo, 10) || this.retailer.retailerId;
    this.requestPayload = {
      ...this.data,
      type: this.type,
      locale: this.locale,
      retailerId: this.retailerId,
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  showNotification() {
    this.Notifications.customNotification(
      {
        message: this.gettextCatalog.getString('Poster is generating...'),
        timeOut: 0,
      },
      'toast',
      'info'
    );
  }

  async handleSocialMediaClick(serviceType) {
    this.showNotification();

    await this.fetchPosterUrl({ ...this.requestPayload, serviceType });

    this.Notifications.clear();

    if (!this.error.posterUrl) {
      const config = 'width=400,height=500,resizable=yes';

      switch (serviceType) {
        case 'facebook':
          this.$window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.url)}`, '_blank', config);
          break;
        case 'twitter':
          this.$window.open(`https://twitter.com/share?url=${encodeURIComponent(this.url)}`, '_blank', config);
          break;
        default:
          // eslint-disable-next-line no-console
          console.error("Can't map social media service type for: ", serviceType);
      }
    }
  }

  async handlePrintClick() {
    this.showNotification();
    await this.downloadPoster(this.requestPayload);
    this.Notifications.clear();
  }
}

export default class RwSocialMediaComponent {
  constructor() {
    this.template = template;
    this.controller = RwSocialMediaController;
    this.bindings = {
      data: '<',
      type: '@',
      isDisabled: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-social-media/rw-social-media-component.js